<template>
  <div>
    <div class="sec-head">
      <div>
        <span class="eyebrow">Good to know</span>
        <h2>Payment &amp; certification terms</h2>
        <p>
          Registration, invoicing and what's required to become certified —
          the details before you need them.
        </p>
      </div>
    </div>
    <div class="pgrid">
      <div v-for="t in course.payment_terms" :key="t.title" class="pcard">
        <b>{{ t.title }}</b>
        <span>{{ t.body }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PaymentTerms',
  props: {
    course: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>
.sec-head {
  margin-bottom: 18px;
}
.eyebrow {
  font-size: 0.8rem;
  font-weight: 700;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: var(--teal-dk);
}
h2 {
  font-size: 1.55rem;
  letter-spacing: -0.01em;
  margin: 4px 0 6px;
}
.sec-head p {
  color: var(--ink-soft);
  font-size: 0.95rem;
  margin: 0;
}
.pgrid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 12px;
}
.pcard {
  border: 1px solid var(--line);
  border-radius: 12px;
  padding: 14px 16px;
  background: var(--white);
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.pcard b {
  font-size: 0.9rem;
}
.pcard span {
  font-size: 0.84rem;
  color: var(--ink-soft);
}
</style>
